module.exports = __webpack_public_path__ + "img/knife.3f5c4a03.webp";